'use strict';

angular.module('auth', [])

    .factory('AuthFactory', function AuthFactory($window, $location, SETTINGS) {
        var store = $window.localStorage;
        var key = 'jwt';

        return {
            getToken: getToken,
            setToken: setToken,
            hasToken: hasToken,
            logout: logout
        };

        function getToken() {
            return store.getItem(key);
        }

        function setToken(token) {
            if (token) {
                store.setItem(key, token);
            } else {
                store.removeItem(key);
            }
        }

        function hasToken() {
            return getToken() !== null;
        }

        function logout() {
            setToken();
            $location.path(SETTINGS.DEFAULT_URL);
        }
    })

    .factory('AuthInterceptor', function AuthInterceptor($q, AuthFactory) {

        return {
            request: request,
            responseError: checkAuth
        };

        // Method to run for every request
        function request(config) {

            // Send token for all API calls
            addToken(config);

            return config;
        }

        // Add Authorization header
        function addToken(config) {

            var token = AuthFactory.getToken();

            if (token) {
                config.headers = config.headers || {};
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config || $q.when(config);
        }

        // Detect and react to 401
        function checkAuth(rejection) {
            if (rejection.status == 401) {
                console.log('Unauthorized request to', rejection.config.url);
                AuthFactory.logout();
            }
            return $q.reject(rejection);
        }
    })
;
